import React, { useState } from "react";
import {
    Box,
    Typography,
    Rating
} from "@mui/material";
import MobileContainer from "../global/components/MobileContainer";
import Navbar from "../global/components/Navbar"; // make sure this is your red navbar logo

const RateExperiencePage: React.FC = () => {
    const [value, setValue] = useState<number | null>(4);

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#fff", display: "flex", flexDirection: "column" }}>
            {/* Red Navbar */}
           <Navbar/>

            {/* Content */}
            <MobileContainer centerContent={false}>
                <Box textAlign="center">
                    <Typography variant="h6" gutterBottom>
                        With this route you saved
                    </Typography>
                    <Typography variant="h4" color="error" fontWeight="bold">
                        3 min
                    </Typography>
                    <Box sx={{ width: 40, height: 2, bgcolor: "error.main", mx: "auto", my: 2 }} />

                    <Typography variant="h6" gutterBottom>
                        Please rate your experience
                    </Typography>
                    <Rating
                        name="rate-experience"
                        value={value}
                        onChange={(_, newValue) => setValue(newValue)}
                        size="large"
                        sx={{
                            "& .MuiRating-iconFilled": {
                                color: "#e4002b",
                            },
                            "& .MuiRating-iconHover": {
                                color: "#ff1a3c",
                            },
                        }}
                    />
                </Box>
            </MobileContainer>
        </Box>
    );
};

export default RateExperiencePage;
